import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const PrivateRoute = ({ children, requiredRole = null }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="private-route-loading">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[hsl(var(--brand-700))] mx-auto"></div>
          <p className="mt-4 text-[hsl(var(--muted-foreground))]">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check role if required
  if (requiredRole && user.role !== requiredRole && user.role !== 'admin') {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="private-route-unauthorized">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-[hsl(var(--destructive))]">Yetkisiz Erişim</h1>
          <p className="mt-2 text-[hsl(var(--muted-foreground))]">Bu sayfaya erişim yetkiniz yok.</p>
        </div>
      </div>
    );
  }

  return children;
};
